<template>
  <div :class="[(conEstilosClaros) ? 'form-group color-claro' : 'form-group']">
    <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} {{mansajeValorDefinidoSingular}}</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} {{mansajeValorDefinidoPlural}}</option>        
        <option v-for="(elemento,index) in elementos" :value="elemento.valor" :key="index">{{elemento.nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'

  export default {
    data() {
      return {
        enumeraciones,
        idDelModelo:null
      }
    },
    props: {            
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      elementos:Array,
      mansajeValorDefinidoPlural: String, 
      mansajeValorDefinidoSingular: String,
      conEstilosClaros: {
          type: Boolean,
          default: false
      },
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo generico
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        let objetoElemento = this.elementos.find(e => e.valor == parseInt(this.idDelModelo));
        this.$emit("valorParaElPadre",evento,objetoElemento);
      }
    }, 
    mounted(){
      // establecer valores default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
        console.log('generico Creado');
    },
    created() {
      
    }
  }
</script>
<style scoped>
.color-claro select {
  background-color: rgb(185, 185, 185);
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Comun/CSelectGenerico.vue